import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { RegisterationAdminDecision,MeasurmentOfficerDecision, Languages, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';

@Component({
  selector: 'app-measurement-officer-fees-new',
  templateUrl: './measurement-officer-fees-new.component.html',
  styleUrls: ['./measurement-officer-fees-new.component.css']
})
export class MeasurementOfficerFeesComponentNew implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  decision = MeasurmentOfficerDecision;
  decisionKeys = Object.keys(this.decision);
  reviewerdecision = RegisterationAdminDecision;
  reviewerdecisionKeys = Object.keys(this.reviewerdecision);
  reviewerdecisionValue: number;
  displayedLang: string; 
 // measurementReviewerForm: FormGroup;
  public measurementOfficerForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentOffcierObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  agentId: string;
  //public formMode: FormMode.Readonly;
  feesEstimationObj: FeesEstimate = new FeesEstimate();
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  public disableForm: boolean = false  ;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService,
    private feesEstimationService: FeesEstimationService, private translate: TranslateService, ) {
    this.isShow = true;
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
   // this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.reviewerdecisionKeys = this.reviewerdecisionKeys.slice(this.reviewerdecisionKeys.length / 2);
    this.user = this.globalSrv.user;

  }

  ngOnInit() {
    this.buildForm(null);

  }

  get f() {
    return this.measurementOfficerForm.controls;
  }

  buildForm(reviewerdecision) {
    this.measurementOfficerForm = this.formBuilder.group({
      ReviewerDecision: ['', [Validators.required]],
    });
    if (reviewerdecision == RegisterationAdminDecision.Approve) {
      this.measurementOfficerForm = this.formBuilder.group({
      ReviewerDecision: ['', [Validators.required]],
      InsuranceValue: new FormControl('', [Validators.pattern(this.numberRegex)]),
      FeeValue: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
     // Decision: ['', Validators.required],
      Currency: new FormControl({ value: '', disabled: true }),
      MeasurementDescription: ['']
    });
    }

    if (reviewerdecision == RegisterationAdminDecision.MoreInformation) {
      this.measurementOfficerForm = this.formBuilder.group({
        ReviewerDecision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });

    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.measurementOfficerForm.patchValue({
      ReviewerDecision: value
    });

    this.reviewerdecisionValue = value;
    if (this.reviewerdecisionValue == RegisterationAdminDecision.Approve){

      if (this.globalSrv.getLanguage() == Languages.Arabic) {

            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameAR,
            });
          }
      else {
            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameEN,
            });
          }
         if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) { // to patch existed fees data when changing option
          this.measurementOfficerForm.patchValue({
            ReviewerDecision: RegisterationAdminDecision.Approve,
            FeeValue: this.feesEstimationObj.FeeValue,
            InsuranceValue: this.feesEstimationObj.InsuranceValue,
            MeasurementDescription: this.feesEstimationObj.MeasurementDescription
          });
         }
    }
    else if(this.reviewerdecisionValue == RegisterationAdminDecision.MoreInformation)
    {
      
      if (this.measurementOfficerForm.disabled ) { //to doesn't patch moreinformation in add or edit mode
       this.measurementOfficerForm.patchValue({
        ReviewerDecision: RegisterationAdminDecision.MoreInformation,
        MoreInformation: this.responseObj.Data['MoreInformation']
        });
      }
    }
  }

  getBaseRequest() {
    this.feesEstimationService.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.feesEstimationObj = this.responseObj.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          if (this.globalSrv.getLanguage() == Languages.Arabic) {

            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameAR,
            });
          }
          else {
            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameEN,
            });
          }
        // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
        //to view "more information" data in case Measurement officer require it from agent and penending agent update
       //or after agent update request and pending Measurement officer approval 
            if (this.responseObj.Data['MoreInformation'] && (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval || this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent )) {
              this.reviewerdecisionValue = RegisterationAdminDecision.MoreInformation;
              this.buildForm(this.reviewerdecisionValue);
              this.measurementOfficerForm.patchValue({
              ReviewerDecision: RegisterationAdminDecision.MoreInformation,
              MoreInformation: this.responseObj.Data['MoreInformation']
              });

              }
            else {
                this.reviewerdecisionValue = RegisterationAdminDecision.Approve;
                //this.buildForm(this.reviewerdecisionValue);
                this.changeDecision(this.reviewerdecisionValue);
                this.measurementOfficerForm.patchValue({
                  ReviewerDecision: RegisterationAdminDecision.Approve,
                  FeeValue: this.feesEstimationObj.FeeValue,
                  InsuranceValue: this.feesEstimationObj.InsuranceValue,
                  MeasurementDescription: this.feesEstimationObj.MeasurementDescription
                });
              }
              this.measurementOfficerForm.disable();
              this.disableForm=true;
              this.measurementOfficerForm.controls.ReviewerDecision.disable();
              console.log(this.formMode);
              console.log(this.measurementOfficerForm.controls.ReviewerDecision.status);
          }

          else if (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval) {
            this.formMode = FormMode.Add;
            this.measurementOfficerForm.enable();
            this.measurementOfficerForm.controls.Currency.disable();
          }
          else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            //************************ */
            if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) {
              this.measurementOfficerForm.enable();
              //this.measurementOfficerForm.controls.Currency.disable();

            }
            else {
              this.measurementOfficerForm.disable();
            }
            this.reviewerdecisionValue = RegisterationAdminDecision.Approve;
            //this.buildForm(this.reviewerdecisionValue);
            this.changeDecision(this.reviewerdecisionValue);
            this.measurementOfficerForm.controls.Currency.disable();
            this.measurementOfficerForm.patchValue({
              ReviewerDecision: RegisterationAdminDecision.Approve,
              FeeValue: this.feesEstimationObj.FeeValue,
              InsuranceValue: this.feesEstimationObj.InsuranceValue,
              MeasurementDescription: this.feesEstimationObj.MeasurementDescription
            });
          }

        }

      }
    )
  }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.measurementOfficerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.MeasurmentOffcierObject = this.measurementOfficerForm.value;
    this.MeasurmentOffcierObject.AdminEmail = this.user.UserName;
    this.MeasurmentOffcierObject.RequestId = this.baseRequestId;
    this.MeasurmentOffcierObject.Decision = this.reviewerdecisionValue;


    this.feesSrv.fillMeasurmentFees(this.MeasurmentOffcierObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.measurementOfficerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
